import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c(VRow,[_c(VCol,{staticClass:"col-12"},[_c('core-field',{attrs:{"type":"autocomplete","field":_vm.protocolField,"value":_vm.protocol.id},on:{"input":_vm.updateProtocol}})],1),_c(VCol,{attrs:{"colspan":12}},[_c('material-chart-card',{attrs:{"type":"Bar","options":_vm.options,"data":_vm.data}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }